import iconLoading from 'styles/images/ic_loading.svg';

export const FallbackWithLogo = ({ title, subTitle, icon = iconLoading }) => {
  return (
    <div className='inner-content loading'>
      <div className='card-loading-wrap' role='artcle'>
        <div className='card-loading-content'>
          <div className='card-loading-box'>
            <img src={icon} alt='loading-ui' width={130} height={130} />
            <div className='card-loader-st01'></div>
            <h1 className='card-loading-tit'>{title}</h1>
            <span className='card-loading-sub-tit'>{subTitle}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
